import type { Material } from './material.interface';

export interface MaterialTopGenotype {
    C_Material_key: number;
    Genotype: string;
    Material: Material;
}
